module.exports = __webpack_public_path__ + "media/reskin-images/icon--star-85419fac.svg";